import * as React from 'react';
import { cn } from '@companion-professional/webutils';
import { headingVariants } from '../Typography';

export const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h3 ref={ref} className={cn(headingVariants({ level: 'section' }), className)} {...props} />
  )
);
CardTitle.displayName = 'CardTitle';
